import { cn } from '@massilia/ui'
import { Check } from 'lucide-react'

const BOOKING_STEPS = ['Choix du vol', 'Informations', 'Assurances', 'Paiement'] as const

interface BookingStepperProps {
  currentStep: number
  onStepClick?: (step: number) => void
}

export function BookingStepper({ currentStep, onStepClick }: BookingStepperProps) {
  return (
    <div className="flex w-full justify-center bg-white p-4">
      <div className="flex w-full max-w-4xl items-center gap-1 md:gap-2">
        {BOOKING_STEPS.map((label, index) => {
          const stepNumber = index + 1
          const isCompleted = stepNumber < currentStep
          const isCurrent = stepNumber === currentStep
          const isUpcoming = stepNumber > currentStep

          return (
            <div key={label} className="flex flex-1 items-center gap-1.5 md:gap-3">
              {/* Step indicator */}
              <div className="flex shrink-0 items-center gap-1.5 md:gap-3">
                {isCompleted && (
                  <button
                    type="button"
                    onClick={() => onStepClick?.(stepNumber)}
                    className="hover:bg-success-700 flex size-6 cursor-pointer items-center justify-center rounded-full bg-success-600 transition-colors"
                  >
                    <Check className="size-4 text-white" strokeWidth={2.5} />
                  </button>
                )}
                {isCurrent && (
                  <div className="flex size-6 items-center justify-center rounded-full bg-brand-600 shadow-[0px_0px_0px_2px_rgba(0,114,195,0.24)]">
                    <div className="size-2 rounded-full bg-white" />
                  </div>
                )}
                {isUpcoming && (
                  <div className="flex size-6 items-center justify-center rounded-full bg-gray-light-50">
                    <span className="text-xs font-normal text-gray-light-700">{stepNumber}</span>
                  </div>
                )}
                <span
                  className={cn(
                    'text-gray-light-900 text-sm font-medium whitespace-nowrap',
                    isCurrent ? 'inline' : 'hidden md:inline'
                  )}
                >
                  {label}
                </span>
              </div>

              {/* Connector line (not after the last step) */}
              {index < BOOKING_STEPS.length - 1 && (
                <div
                  className={cn(
                    'h-0.5 flex-1 rounded-full',
                    isCompleted && 'bg-success-600',
                    isCurrent && 'bg-brand-600',
                    isUpcoming && 'bg-gray-light-50'
                  )}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
